import { SET_CREDENTIAL } from './types.js'
import axios from 'axios'

export default {
    updateCredentials({ commit }, payload ) {
        commit(SET_CREDENTIAL, payload)
    },
    async login (context) {
      let param = {
        UserName: context.state.username,
        UserPass: context.state.password,
        token: context.state.token
      }

      const login = await axios.post('/api/auth/login', param)
        .then(async response => {
            return Promise.resolve(response)
        })
        .catch((error) => {
            return Promise.reject(error.response.data)
        })

        return login
    }
}